import { LineChart } from "@mantine/charts";
import { Box, Stack, Text } from "@mantine/core";
import { TooltipProps } from "recharts";
import {
  formatCurrencyFromPence,
  formatDateToLocalString,
  localDateToJSDate,
} from "../../../utils";
import { LedgerEntry_Net } from "../../../backend/types-v2";
import { BalanceDay } from "../../../backend/build-ledger";
import { PresentationalTransaction } from "./Projector";

const CustomTooltip = ({
  active,
  payload = [],
}: TooltipProps<number, string>) => {
  if (active && payload.length) {
    // tooltip payload type is coming as 'any' - so parse here to keep
    // accessing the object safe.
    const parsedPayload: BalanceDay = payload[0].payload as BalanceDay;

    return (
      <Box style={{ border: "1px solid red" }} bg="var(--mantine-color-body)">
        <Stack>
          <Text>
            {formatDateToLocalString(localDateToJSDate(parsedPayload.date))} |{" "}
            {formatCurrencyFromPence(parsedPayload.closingBalancePence)}
          </Text>
          {parsedPayload.transactions.length > 0 ? (
            <ul>
              {parsedPayload.transactions.map((number: LedgerEntry_Net) => {
                return (
                  <li key={number.itemId}>
                    <Text>
                      {number.name} (
                      {formatCurrencyFromPence(number.amountPence)})
                    </Text>
                  </li>
                );
              })}
            </ul>
          ) : (
            <Text>No transactions</Text>
          )}
        </Stack>
      </Box>
    );
  }
};

export function DataChart2({
  transactions,
}: {
  transactions: PresentationalTransaction[];
}) {
  return (
    <LineChart
      h={300}
      mt="lg"
      data={transactions.filter(
        (i, index) => i.transactions.length > 0 || index === 0,
      )}
      dataKey="date"
      series={[{ name: "closingBalancePence", color: "teal.6" }]}
      curveType="monotone"
      lineChartProps={{}}
      valueFormatter={formatAbbreviatedCurrency}
      // tickLine="y"
      tooltipProps={{ content: CustomTooltip }}
    />
  );
}

const formatAbbreviatedCurrency = (value: number) => {
  const pounds = value / 100; // convert from pence

  if (Math.abs(pounds) >= 1_000_000) {
    return `£${(pounds / 1_000_000).toFixed(1)}m`;
  }

  if (Math.abs(pounds) >= 1_000) {
    return `£${(pounds / 1_000).toFixed(0)}k`;
  }

  return `£${pounds}`;
};
